// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----Contact-module---container---3tG1O","dots":"src-components----Contact-module---dots---1mYMp","dot":"src-components----Contact-module---dot---2aJvf","dot2":"src-components----Contact-module---dot2---2bqm3","dot3":"src-components----Contact-module---dot3---26cbP","pulse":"src-components----Contact-module---pulse---1CIbs","indicator":"src-components----Contact-module---indicator---u5WBm","chat":"src-components----Contact-module---chat---3MjGA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact.module.css
// module id = 120
// module chunks = 35783957827783 43201937662106